import React from "react";
import { Link } from "react-router-dom";
import MobileMenus from "../../common/Menu/MobileMenus";

const OffCanvas = ({ setOffCanvas, isOffCanvas }) => {
  return (
    <>
      <div
        className={`offcanvas__area off-canvas-bg ${isOffCanvas ? "opened" : ""
          }`}
        style={{ background: '#f7b902' }}
      >
        <div className="offcanvas_area-logo">
          <span className="offcanvas__close-btn">
            <button onClick={() => setOffCanvas(false)}>
              <i className="fal fa-times" />
            </button>
          </span>
        </div>
        <div className="offcanvas-content">
          <div className="offcanvas-subtitle">
            <span>ELEVATE YOUR BUSINESS WITH</span>
          </div>
          <div className="offcanvas-logo pb-30 pt-30">
            <a href="https://sapientcreative.ro/" target="_blank" rel="noopener noreferrer">
              <img src="assets/img/logo/creative-white.png" alt="" />
            </a>
          </div>
          {/* <div className="offcanva-details">
            <p>
              Limitless customization options & Elementor compatibility let
              anyone create a beautiful website with Valiance.
            </p>
          </div> */}
          <div className="offcanva-btn">
            <a
              href="https://sapientcreative.ro/"
              className="tp-slider-btn mt-40 d-inline-block"
              tabIndex="-1"
              target="_blank"
              rel="noopener noreferrer"
            >
              <span>
                <svg
                  width="53"
                  height="8"
                  viewBox="0 0 53 8"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M52.3536 4.35356C52.5488 4.15829 52.5488 3.84171 52.3536 3.64645L49.1716 0.464469C48.9763 0.269207 48.6597 0.269207 48.4645 0.464469C48.2692 0.659731 48.2692 0.976314 48.4645 1.17158L51.2929 4L48.4645 6.82843C48.2692 7.02369 48.2692 7.34027 48.4645 7.53554C48.6597 7.7308 48.9763 7.7308 49.1716 7.53554L52.3536 4.35356ZM-3.11023e-08 4.5L52 4.5L52 3.5L3.11023e-08 3.5L-3.11023e-08 4.5Z"
                    fill="currentColor"
                  ></path>
                </svg>
                <svg
                  width="53"
                  height="8"
                  viewBox="0 0 53 8"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M52.3536 4.35356C52.5488 4.15829 52.5488 3.84171 52.3536 3.64645L49.1716 0.464469C48.9763 0.269207 48.6597 0.269207 48.4645 0.464469C48.2692 0.659731 48.2692 0.976314 48.4645 1.17158L51.2929 4L48.4645 6.82843C48.2692 7.02369 48.2692 7.34027 48.4645 7.53554C48.6597 7.7308 48.9763 7.7308 49.1716 7.53554L52.3536 4.35356ZM-3.11023e-08 4.5L52 4.5L52 3.5L3.11023e-08 3.5L-3.11023e-08 4.5Z"
                    fill="currentColor"
                  ></path>
                </svg>
              </span>
              Get in touch
            </a>
          </div>
        </div>

        <div className="tp-mobile-menu mean-container d-block d-xl-none">
          <div className="mean-bar">
            <MobileMenus />
          </div>
        </div>

        <div className="tp-footer__widget pb-30 offcanvas-ct-info">
          <h3 className="tp-footer__widget-title">Quick Links</h3>
          <ul>
            <li>
              <a href="https://www.google.com/maps/dir//Strada+Vasile+Alecsandri+1,+Oradea+410072/@47.0541871,21.8466704,12z/data=!4m8!4m7!1m0!1m5!1m1!1s0x474647e89ec94beb:0x4ccd041dd32ef03e!2m2!1d21.9290709!2d47.0542167?entry=ttu" target="_blank" rel="noopener noreferrer">Str. Vasile Alecsandri nr.1, Oradea, Bihor</a>
            </li>
            <li>
              <a href="tel:+40359405677">+40 359 405 677</a>
            </li>
            <li>
              <Link to="#">office@sapientgroup.ro</Link>
            </li>
            <li>
              <span> Office Hours: 9AM - 5PM</span>
            </li>
            <li>
              <span> Monday - Friday </span>
            </li>
          </ul>
        </div>
      </div>
      <div
        onClick={() => setOffCanvas(false)}
        className={`body-overlay ${isOffCanvas ? "opened" : ""}`}
      ></div>
    </>
  );
};

export default OffCanvas;
